var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFloat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mflvxt03aa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8442",
    style: {
      fill: "none"
    },
    d: "M0 0h24v30H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 474",
    style: {
      clipPath: "url(#mflvxt03aa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33493",
    d: "m31.6 51.491-.036 12.186c0 .353-.542.553-.918.338l-.067-.039-.474-.272-.513-.295-.038-.022-3.13-1.795a.729.729 0 0 0-.692 0l-3.107 1.765-.038.022-.513.292-.475.269-.099.06c-.377.213-.917.013-.916-.34l.036-12.186c0-.235.257-.426.572-.425h1.439l6.93.012h1.477c.315 0 .57.192.569.427",
    transform: "translate(-13.876 -34.103)",
    style: {
      fill: "#f7373e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33494",
    d: "M25.683 51.051V63.38l-.513.292V51.05z",
    transform: "translate(-16.97 -34.105)",
    style: {
      fill: "#f7d219"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33495",
    d: "M48.762 51.09v12.642l-.513-.295V51.089z",
    transform: "translate(-32.531 -34.131)",
    style: {
      fill: "#f7d219"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33496",
    d: "M23.343 12.4c0-.71.761-1.478.645-2.154-.12-.695-1.095-1.152-1.326-1.8s.221-1.648-.12-2.248-1.414-.698-1.853-1.226-.342-1.622-.866-2.072-1.557-.16-2.151-.511S16.811.985 16.164.745s-1.511.394-2.193.273C13.307.9 12.7 0 12 0s-1.307.9-1.971 1.017c-.682.122-1.556-.508-2.193-.272s-.919 1.3-1.508 1.645-1.628.064-2.151.51-.426 1.537-.866 2.071S1.8 5.594 1.458 6.2s.116 1.588-.12 2.248S.132 9.553.012 10.247c-.116.676.645 1.444.645 2.154S-.1 13.879.012 14.555c.12.695 1.095 1.152 1.327 1.8S1.118 18 1.458 18.6s1.414.695 1.853 1.227.342 1.623.866 2.071 1.558.16 2.151.511.861 1.405 1.508 1.645 1.511-.394 2.193-.273C10.693 23.9 11.3 24.8 12 24.8s1.307-.9 1.971-1.017c.682-.122 1.557.509 2.193.273s.919-1.3 1.508-1.645 1.629-.064 2.152-.511.426-1.537.866-2.071 1.509-.621 1.852-1.227-.116-1.588.12-2.248 1.207-1.106 1.327-1.8c.116-.676-.645-1.444-.645-2.154",
    style: {
      fill: "#f9c810"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33497",
    d: "M26.311 17.183a9.933 9.933 0 0 0-9.839-10.025 9.933 9.933 0 0 0-9.839 10.025 9.933 9.933 0 0 0 9.839 10.025 9.933 9.933 0 0 0 9.839-10.025",
    transform: "translate(-4.472 -4.782)",
    style: {
      fill: "#f29121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33498",
    d: "M27.6 19.654a8.635 8.635 0 1 0-8.634 8.8 8.717 8.717 0 0 0 8.634-8.8",
    transform: "translate(-6.967 -7.253)",
    style: {
      fill: "#f9c810"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33499",
    d: "M10.752 20.119a8.717 8.717 0 0 1 8.634-8.8 8.529 8.529 0 0 1 6.141 2.614 8.55 8.55 0 0 0-6.56-3.078 8.716 8.716 0 0 0-8.634 8.8 8.853 8.853 0 0 0 2.493 6.183 8.859 8.859 0 0 1-2.074-5.719",
    transform: "translate(-6.967 -7.254)",
    style: {
      fill: "#f7d219"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 33500",
    d: "m26.7 21.652 1.148 2.371a.724.724 0 0 0 .544.4l2.568.38a.74.74 0 0 1 .4 1.256l-1.858 1.845a.745.745 0 0 0-.208.652l.438 2.606a.726.726 0 0 1-1.049.776l-2.3-1.23a.711.711 0 0 0-.673 0l-2.3 1.23a.726.726 0 0 1-1.049-.776l.438-2.606a.745.745 0 0 0-.208-.652l-1.858-1.845a.74.74 0 0 1 .4-1.256l2.567-.38a.724.724 0 0 0 .544-.4l1.148-2.371a.717.717 0 0 1 1.3 0",
    transform: "translate(-13.841 -14.19)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloat);
export default __webpack_public_path__ + "static/media/icon_float.eeb8c6150b9c091d0ae54828da899270.svg";
export { ForwardRef as ReactComponent };